import { Injectable } from "@nestjs/common";
import { DownTimeTracking } from "./downtime-tracking.entity";
import { DowntimeTrackingDto } from "./downtime-tracking.dto";


@Injectable()

export class DownTimeTrackingAdapter{

    public convertDtoToEntity(downtimetrackingDto:DowntimeTrackingDto,isUpdate:boolean=false):DownTimeTracking{
        console.log(downtimetrackingDto,'dto',isUpdate,'is update')
        const downtimeTracking =new DownTimeTracking();
        
        downtimeTracking.downtimeTrackingId=downtimetrackingDto.downtimeTrackingId;
        downtimeTracking.departmentId=downtimetrackingDto.departmentId;
        downtimeTracking.category=downtimetrackingDto.category;
        downtimeTracking.machineName=downtimetrackingDto.machineName;
        downtimeTracking.saleorderId=downtimetrackingDto.saleorderId;
        downtimeTracking.startTime=downtimetrackingDto.startTime
        downtimeTracking.status=downtimetrackingDto.status;
        downtimeTracking.downtimetype=downtimetrackingDto.downtimetype;
        downtimeTracking.employeeId=downtimetrackingDto.employeeId;
        downtimeTracking.plannedtime=downtimetrackingDto.plannedtime;
        downtimeTracking.reasonId=downtimetrackingDto.reasonId;
        downtimeTracking.assetId=downtimetrackingDto.assetId;
        downtimeTracking.unitId=downtimetrackingDto.unitId;
        downtimeTracking.machineCode=downtimetrackingDto.machineCode;
        downtimeTracking.resolution=downtimetrackingDto.resolution;
        downtimeTracking.assetCategoryId=downtimetrackingDto.assetCategoryId
        // downtimeTracking.endtime=downtimetrackingDto.endtime;
        downtimeTracking.isActive=downtimetrackingDto.isActive==undefined?true:downtimetrackingDto.isActive;
        if(!isUpdate){
            downtimeTracking.endtime= null;
            downtimeTracking.plannedtime=null;
        }

        if(isUpdate){
            downtimeTracking.reasonId=downtimetrackingDto.reasonId;
            downtimeTracking.impact=downtimetrackingDto.impact;
            downtimeTracking.remarks=downtimetrackingDto.remarks;
            downtimeTracking.resources=downtimetrackingDto.resources;
            downtimeTracking.machineCode=downtimetrackingDto.machineCode;
            downtimeTracking.machineName=downtimetrackingDto.machineName? downtimetrackingDto.machineName:null;
            downtimeTracking.updatedUser=downtimetrackingDto.updatedUser;
            downtimeTracking.endtime=downtimetrackingDto.endtime
            downtimeTracking.plannedtime=downtimetrackingDto.plannedtime ? downtimetrackingDto.plannedtime : null;

        }
        else{
            downtimeTracking.isActive=true;
            downtimeTracking.createdUser=downtimetrackingDto.createdUser;
        }
        console.log(downtimeTracking,'converted dto')
        return downtimeTracking;

    }

    public convertEntityToDto(downtimTrackingObeject:DownTimeTracking):DowntimeTrackingDto{

        const downtimetrackingDto=new DowntimeTrackingDto;
        downtimetrackingDto.downtimeTrackingId=downtimTrackingObeject.downtimeTrackingId;
        downtimetrackingDto.departmentId=downtimTrackingObeject.departmentId;
        downtimetrackingDto.category=downtimTrackingObeject.category;
        downtimetrackingDto.startTime=downtimTrackingObeject.startTime;
        downtimetrackingDto.reasonId=downtimTrackingObeject.reasonId;
        downtimetrackingDto.status=downtimTrackingObeject.status;
        downtimetrackingDto.endtime=downtimTrackingObeject.endtime;
        downtimetrackingDto.impact=downtimTrackingObeject.impact;
        downtimetrackingDto.remarks=downtimTrackingObeject.remarks;
        downtimetrackingDto.saleorderId=downtimTrackingObeject.saleorderId;
        downtimetrackingDto.machineName=downtimTrackingObeject.machineName;
        downtimetrackingDto.resources=downtimTrackingObeject.resources;
        downtimetrackingDto.downtimetype=downtimTrackingObeject.downtimetype;
        downtimetrackingDto.plannedtime=downtimTrackingObeject.plannedtime;
        downtimetrackingDto.isActive=downtimTrackingObeject.isActive;
        downtimetrackingDto.createdUser=downtimTrackingObeject.createdUser;
        downtimetrackingDto.employeeId=downtimTrackingObeject.employeeId;
        downtimetrackingDto.unitId=downtimTrackingObeject.unitId
        downtimetrackingDto.machineCode=downtimTrackingObeject.machineCode;
        downtimetrackingDto.resolution=downtimTrackingObeject.resolution;
        downtimetrackingDto.assetId=downtimTrackingObeject.assetId;
        downtimetrackingDto.assetCategoryId=downtimTrackingObeject.assetCategoryId;

        return downtimetrackingDto;



    }


}